// export async function sendChatMessage(
// 	query,
// 	onChunk
// ) {
// 	try {
// 		/// 构建请求对象
// 		// const reqParams = {
// 		// 	query,
// 		// 	response_mode: 'streaming',
// 		// 	user: 'web-user-' + Date.now().toString(),
// 		// 	inputs: {},
// 		// };
//
// 		// 设置请求头
// 		const headers = {
// 			'Content-Type': 'application/json',
// 			Authorization: `Bearer ${localStorage.getItem('token')}`,
// 		};
//
// 		// 发送请求
// 		const response = await fetch(`${process.env.VUE_APP_BASE_API}/ai/knowledge/search`, {
// 			method: 'POST',
// 			headers,
// 			body: JSON.stringify(query)
// 		});
//
// 		if (!response.ok) {
// 			throw new Error(`API请求失败: ${response.status}`);
// 		}
//
// 		// 处理SSE流式响应
// 		const reader = response.body?.getReader();
// 		if (!reader) {
// 			throw new Error('无法读取响应流');
// 		}
// 		const decoder = new TextDecoder();
// 		let buffer = '';
// 		let isDone = false; // 添加一个标志变量
// 		while (!isDone) {
// 			const { done, value } = await reader.read();
// 			isDone = done; // 更新标志变量
// 			if (done) break;
//
// 			// 将二进制数据转换为文本
// 			buffer += decoder.decode(value, { stream: true });
//
// 			// 处理buffer中的事件
// 			while (buffer.includes('\n\n')) {
// 				const eventEndIndex = buffer.indexOf('\n\n');
// 				const eventData = buffer.substring(0, eventEndIndex);
// 				buffer = buffer.substring(eventEndIndex + 2);
// 				// console.log('eventData:', eventData, 111);
//
// 				// 解析事件数据
// 				if (eventData.startsWith('data:')) {
// 					try {
// 						// console.log('eventData:', eventData);
// 						const jsonStr = eventData.substring(5); // 去掉 'data: ' 前缀
// 						const data = JSON.parse(jsonStr);
// 						// console.log('data:', data);
//
// 						// 根据事件类型处理
// 						if (data.code === 200) {
// 							// 回调传递内容
// 							onChunk(data.msg_type, data.data.msg || '');
// 						}  else {
// 							// 错误事件
// 							onChunk('error', data.data || '发生错误');
// 							console.error('API错误:', data);
// 						}
// 					} catch (e) {
// 						console.error('解析事件数据失败:', e);
// 					}
// 				}
// 			}
// 		}
// 	} catch (e) {
// 		console.error('API调用错误:', e);
// 		onChunk('error', '\n[API调用失败，请重试]');
// 		throw e;
// 	}
// }


import { getSecretKey } from '@/api'
import { aesEncryptFixed } from '@/utils/CryptUtil'

/**
 * 让出主线程，避免同一 TCP 块内多条 SSE 在同一同步栈里连续 onChunk，被 Vue2 合并成一次 DOM 更新。
 * 后台标签页 / 不可见文档会暂停 requestAnimationFrame，若仍用 rAF 会导致整条 SSE 循环阻塞直至页面重新可见。
 */
function yieldToPaint() {
	return new Promise((resolve) => {
		const useTimer =
			typeof document !== 'undefined' &&
			(document.hidden || typeof requestAnimationFrame !== 'function')
		if (useTimer) {
			setTimeout(resolve, 0)
		} else {
			requestAnimationFrame(() => resolve())
		}
	})
}

/** 开发环境默认打印；生产需在 .env 设置 VUE_APP_LOG_SSE=true 后重新 build */
function logSseChatPayload(data) {
	if (process.env.NODE_ENV !== 'development' && process.env.VUE_APP_LOG_SSE !== 'true') {
		return
	}
	// console.log('[SSE chat/completions/v2]', new Date().toISOString(), data)
}

export async function sendChatMessage(
	query,
	onChunk
) {
	try {
		// 设置请求头
		const headers = {
			"Content-Type": 'application/json',
			"Cache-Control": "no-cache",
			"Connection": "keep-alive",
			"Accept": "text/event-stream",
			"Authorization": `Bearer ${localStorage.getItem('token')}`,
		};
		let secretResult = await getSecretKey(aesEncryptFixed("langshoudata.com@2026"))
		const bearer = secretResult.data

		// 发送请求
		const response = await fetch(`${process.env.VUE_APP_BASE_API}/api/v2/ai/chat/completions/v2?bearer=${encodeURIComponent(bearer)}`, {
		// const response = await fetch(`http://localhost:8080/api/v2/ai/chat/completions/v2?bearer=${encodeURIComponent(bearer)}`, {
			method: 'POST',
			headers,
			body: JSON.stringify(query)
		});

		if (!response.ok) {
			throw new Error(`API请求失败: ${response.status}`);
		}

		// 处理SSE流式响应
		const reader = response.body?.getReader();
		if (!reader) {
			throw new Error('无法读取响应流');
		}
		const decoder = new TextDecoder();
		let buffer = '';
		let isDone = false; // 添加一个标志变量
		while (!isDone) {
			const { done, value } = await reader.read();
			isDone = done; // 更新标志变量
			if (done) break;

			// 将二进制数据转换为文本
			buffer += decoder.decode(value, { stream: true });

			// 处理buffer中的事件
			while (buffer.includes('\n\n')) {
				const eventEndIndex = buffer.indexOf('\n\n');
				const eventData = buffer.substring(0, eventEndIndex);
				buffer = buffer.substring(eventEndIndex + 2);
				// console.log('eventData:', eventData, 111);

				// 解析事件数据
				if (eventData.startsWith('data:')) {
					try {
						const jsonStr = eventData.substring(5); // 去掉 'data: ' 前缀
						const data = JSON.parse(jsonStr);
						logSseChatPayload(data)
						await yieldToPaint()
						onChunk(data);
					} catch (e) {
						console.error('解析事件数据失败:', e);
					}
				}
			}
		}
	} catch (e) {
		console.error('API调用错误:', e);
		onChunk('error', '\n[API调用失败，请重试]');
		throw e;
	}
}
